module.exports = __webpack_public_path__ + "img/fosunAmount.1c7c5e98.png";